<template>
    <button class="dtx-btn" :class="{
        'lg': size == 'lg',
        'md': size == 'md', 
        'sm': size == 'sm',
        'primary': variant == 'primary',
        'secondary': variant == 'secondary',
        'subtle': variant == 'subtle',
        'danger': variant == 'danger',
        'success': variant == 'success'}" @click="$emit('click')"  :disabled="disabled">
        <slot v-if="!isProcessing" name="default"> {{ label }} </slot>
        <span v-else>
            <i :class="['fa', selectedIcon, 'fa-spin']"></i> {{ busyLabel }}
        </span>
    </button>
</template>

<script>
export default {
    name: 'LockButton',
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: 'lg',
        },
        variant: {
            type: String,
            default: 'primary',
        },
        label: {
            type: String,
            default: 'Button',
        },
        isProcessing: {
            type: Boolean,
            default: false,
        },
        selectedIcon: {
            type: String,
            default: 'fa-circle-o-notch', // fa-spinner, fa-cog, fa-refresh, fa-circle-o-notch
        },
        busyLabel: {
            type: String,
            default: 'Procesando...',
        }
    },
};
</script>

<style lang="scss">
.dtx-btn {
    background-color: var(--primary);
    padding: 0.5em 1em;
    border-radius: 5px !important;
    text-transform: uppercase;
    &, span {
        color: #fff;
    }
    &.lg {
        font-size: 1.25rem;
    }
    &.md {
        font-size: 1rem;
    }
    &.sm {
        font-size: 0.875rem;
    }
    &.primary {
        background-color: var(--primary);
        color: var(--white);
    }
    &.secondary {
        background-color: var(--secondary);
    }
    &.subtle {
        background-color: var(--gray);
    }
    &.danger {
        background-color: var(--danger);
    }
    &.success {
        background-color: var(--success);
    }
}
</style>